import styled from "@emotion/styled"
import { Box, Grid, Typography } from "@mui/material"
import * as api from "api"
import CheckIcon from "common/icons/CheckIcon"
import colorLuminance from "common/utils/colorLuminance"
import { useEffect, useState } from "react"

const Styled = {
  Wrapper: styled.div`
    margin: 10px 0;
    ${(p) => p.theme.breakpoints.up("md")} {
      margin: 30px 0;
    }
  `,
  Button: styled(Box)<{ color: string }>`
    width: 30px;
    height: 30px;
    padding: 4px;
    border-radius: 5px;
    background-color: ${(p) => p.theme.colors.silver};

    ${(p) => p.theme.breakpoints.up("md")} {
      width: 36px;
      height: 36px;
      border-radius: 3px;
    }

    svg {
      width: auto;
      height: 18px;
      ${(p) => p.theme.breakpoints.up("md")} {
        height: 20px;
      }
    }

    label {
      border-radius: 3px;
      width: 22px;
      height: 22px;
      align-items: center;
      justify-content: center;
      display: flex;
      cursor: pointer;
      background-color: ${(p) => p.color};

      ${(p) => p.theme.breakpoints.up("md")} {
        width: 28px;
        height: 28px;
      }
    }

    input[type="radio"] + label svg {
      display: none;
    }

    input[type="radio"]:checked + label svg {
      display: block;
      fill: ${(p) =>
        colorLuminance(p.color) > 130
          ? p.theme.colors.marine
          : p.theme.colors.white};
    }

    input[type="radio"] {
      display: none;
    }
  `,
  Color: styled(Typography)`
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
    margin-bottom: 10px;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      margin-bottom: 18px;
      font-size: 16px;
    }
  `,
}

type VehicleColorsProps = {
  data: api.VehicleOutColors[]
  onSelected: (images: api.ImageModel[]) => void
  onUserSelect: () => void
}

const VehicleColors = ({
  data,
  onSelected,
  onUserSelect,
}: VehicleColorsProps) => {
  const [selected, setSelected] = useState<api.VehicleOutColors>(data[0])

  useEffect(() => {
    onSelected(selected.images)
  }, [onSelected, selected])

  if (!data[0]) {
    return null
  }

  return (
    <Styled.Wrapper>
      <Styled.Color>{selected.name}</Styled.Color>
      <Grid container spacing={3} justifyContent={"center"}>
        {data.map((color) => (
          <Grid item key={color.code}>
            <Styled.Button color={color.hex}>
              <input
                id={color.code}
                name="selected-color"
                type="radio"
                checked={color.code === selected.code}
                onChange={() => {
                  onUserSelect()
                  setSelected(color)
                }}
              />
              <label htmlFor={color.code}>
                <CheckIcon htmlColor="white" />
              </label>
            </Styled.Button>
          </Grid>
        ))}
      </Grid>
    </Styled.Wrapper>
  )
}

export default VehicleColors
